import { useCallback } from 'react';
import useProductSelectionStore from '../../stores/useProductSelectionStore';
import useAlbumSelectionStore from '../../stores/useAlbumSelectionStore';
import { ReactComponent as WarningIcon } from '../../images/icons/ProductSelectionPage/warningicon.svg';
import { ReactComponent as PlusCircleIcon } from '../../images/icons/ProductSelectionPage/pluscircleicon.svg';

const AlbumStatusBar = ({ onSave }) => {
  const { photos } = useProductSelectionStore();
  const { albumItems } = useAlbumSelectionStore();
  const totalCount = photos.length;
  const droppedCount = albumItems.length;


  const handleSave = useCallback(() => {
    onSave?.();
  }, [onSave]);

  const formattedDroppedCount = droppedCount.toString().padStart(2, '0');
  const formattedTotalCount = totalCount.toString().padStart(2, '0');

  return (
    <div className="div-block-324">
      <div className="div-block-325">
        <div className="sub-heading-container-2 both-edges no-margin">
        </div>

        <div className="div-block-326">
          <div className="w-layout-grid grid-23 main _2 _100 grey">
            {/* <div className="green">
              <div className="icon small x2 w-embed">
                <WarningIcon />
              </div>
            </div>
            <div>
              <span>{formattedDroppedCount}</span>
              <span className="green">/{formattedTotalCount}</span> pictures in album
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlbumStatusBar;